export function formatDuration(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}

export function formatCount(count: number): string {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  return count.toString();
}

export function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d
    .getDate()
    .toString()
    .padStart(2, '0')}`;
}

export function timeAgo(dateStr: string, now: Date = new Date()): string {
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  const diff = now.getTime() - d.getTime();
  const day = 24 * 60 * 60 * 1000;
  if (diff < day) return '今天';
  if (diff < 2 * day) return '昨天';
  if (diff < 7 * day) return `${Math.floor(diff / day)} 天前`;
  if (diff < 30 * day) return `${Math.floor(diff / (7 * day))} 周前`;
  return formatDate(dateStr);
}

/**
 * Returns true if the published date falls within the given time filter.
 */
export function isWithinTime(
  dateStr: string,
  timeFilter: string,
  now: Date = new Date(),
): boolean {
  if (timeFilter === 'all' || !timeFilter) return true;
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return true;
  const diff = now.getTime() - d.getTime();
  const day = 24 * 60 * 60 * 1000;
  if (timeFilter === 'today') return diff < day && d.getDate() === now.getDate();
  if (timeFilter === 'week') return diff < 7 * day;
  if (timeFilter === 'month') return diff < 30 * day;
  return true;
}